import Layout from '@/layout/base/layoutSegfy'

export default [{
    path: '/Retrospectiva',
    component: Layout,
    children: [
        {
            path: '',
            component: () => import('@/components/retrospectiva/retrospectiva'),
            meta: {
                auth: true
            }
        }
    ]
}]
